import { FormattedMessage } from 'react-intl';

import ErrorBoundary from '~components/generic/error-boundary/ErrorBoundary';
import { MediaLibraryFavouritesList } from '~extension/favourite/components/MediaLibraryFavouritesList';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import MediaLibraryProviderBag from '~modules/media-library/context/MediaLibraryProviderBag';
import { selectAddonsIsMediaLibraryEnabled } from '~store/selectors';

export function MediaLibraryFavourites() {
  const isMediaLibraryEnabled = useAppSelector(selectAddonsIsMediaLibraryEnabled);

  const { hlFavouritesAsset } = useLabels(['hlFavouritesAsset']);

  if (!isMediaLibraryEnabled) return null;

  return (
    <>
      <h2>{hlFavouritesAsset}</h2>
      <span>
        <FormattedMessage
          id="msgFavouritesAsset"
          values={{
            br: <br />,
          }}
        />
      </span>
      <ErrorBoundary>
        <MediaLibraryProviderBag>
          <MediaLibraryFavouritesList />
        </MediaLibraryProviderBag>
      </ErrorBoundary>
    </>
  );
}
